import { HttpClient } from '@angular/common/http';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatFormFieldModule, MatIconModule, MatInputModule, MatOptionModule, MatPaginatorModule, MatTableModule } from '@angular/material';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { HttpLoaderFactory, SharedModule } from '../shared/shared.module';
import { SearchHeaderItemAmountComponent } from './search-header-item-amount/search-header-item-amount.component';
import { SearchResultContainerComponent } from './search-result-container/search-result-container.component';
import { SearchResultHeaderComponent } from './search-result-header/search-result-header.component';
import { SearchComponent } from './search.component';
import { CommonModule } from '@angular/common';
//import { GlobalErrorHandlerService } from '../global-error-handler.service';



@NgModule({
  declarations: [
    SearchComponent,
    SearchHeaderItemAmountComponent,
    SearchResultContainerComponent,
    SearchResultHeaderComponent,  
  ],
  imports: [
    FormsModule,
    CommonModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatOptionModule,
    MatPaginatorModule,
    MatTableModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers : [
    /*{  
      provide: ErrorHandler ,
      useClass: GlobalErrorHandlerService
     }*/
  ],
  exports: [
    SearchComponent,
  ]
})
export class SearchModule { }
